module.exports = __webpack_public_path__ + "static/media/tyre-red-three2.42d023cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-three2.png
// module id = 339
// module chunks = 0